import { Directive, ElementRef, inject, Input } from '@angular/core';

import { TooltipPosition } from '@kros-sk/ui/tooltip';

@Directive({
  selector: 'kros-input-hint, [krosInputHint]',
  host: {
    class: 'kros-form-field-hint',
  },
  standalone: false,
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class KrosInputHint {
  readonly nativeElement = inject(ElementRef).nativeElement;
  @Input() align: TooltipPosition = 'above';
}
